import getOptionsFromElement from "./getOptionsFromElement.js";
import renderers from "../renderers";
import { InvalidElementException } from "../exceptions/exceptions.js";
function getRenderProperties(element) {
  if (typeof element === "string") {
    return querySelectedRenderProperties(element);
  } else if (Array.isArray(element)) {
    var returnArray = [];
    for (let i = 0; i < element.length; i++) {
      returnArray.push(getRenderProperties(element[i]));
    }
    return returnArray;
  } else if (typeof HTMLCanvasElement !== "undefined" && element instanceof HTMLImageElement) {
    return newCanvasRenderProperties(element);
  } else if (element && element.nodeName && element.nodeName.toLowerCase() === "svg" || typeof SVGElement !== "undefined" && element instanceof SVGElement) {
    return {
      element,
      options: getOptionsFromElement(element),
      renderer: renderers.SVGRenderer
    };
  } else if (typeof HTMLCanvasElement !== "undefined" && element instanceof HTMLCanvasElement) {
    return {
      element,
      options: getOptionsFromElement(element),
      renderer: renderers.CanvasRenderer
    };
  } else if (element && element.getContext) {
    return {
      element,
      renderer: renderers.CanvasRenderer
    };
  } else if (element && typeof element === "object" && !element.nodeName) {
    return {
      element,
      renderer: renderers.ObjectRenderer
    };
  } else {
    throw new InvalidElementException();
  }
}
function querySelectedRenderProperties(string) {
  var selector = document.querySelectorAll(string);
  if (selector.length === 0) {
    return void 0;
  } else {
    let returnArray = [];
    for (let i = 0; i < selector.length; i++) {
      returnArray.push(getRenderProperties(selector[i]));
    }
    return returnArray;
  }
}
function newCanvasRenderProperties(imgElement) {
  var canvas = document.createElement("canvas");
  return {
    element: canvas,
    options: getOptionsFromElement(imgElement),
    renderer: renderers.CanvasRenderer,
    afterRender: function() {
      imgElement.setAttribute("src", canvas.toDataURL());
    }
  };
}
var stdin_default = getRenderProperties;
export {
  stdin_default as default
};
